export const USER_ROUTE = '/profile'
export const LOGIN_ROUTE = '/login'
export const REGISTRATION_ROUTE = '/registration'
export const FEED_ROUTE = '/feed'
export const USERS_ROUTE = '/network'
export const CHAT_ROUTE = '/chat'


